import type { Variants } from 'framer-motion';

type CubicBezier = [number, number, number, number];

/** Shared easing curve for all landing animations. */
export const easing: CubicBezier = [0.22, 1, 0.36, 1];

/**
 * Fade + rise variant. Accepts an optional `custom` delay (in seconds) so it
 * can be reused for both staggered children and manually delayed elements.
 */
export const fadeUp: Variants = {
    hidden: { opacity: 0, y: 20 },
    show: (delay: number = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, delay, ease: easing },
    }),
};

/** Stagger container that reveals its children in sequence. */
export const stagger: Variants = {
    show: { transition: { staggerChildren: 0.1 } },
};
